import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getBlockedIpFormInputs } from "../model/blocked-ip.modal";
import { menuUrl } from "../blocked-ip-list/model/blocked-ip-list.constants";
import { editBlockedIpApi } from "./blocked-ip-edit.component.service";
import BlockedIpEditTemplateComponent from "./blocked-ip-edit-template.component";
import { APP } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  BLOCKED_IP_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const BlockedIpEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const { PRIMARY_KEY } = APP;
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleBlockedIpSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let blockedIpPayload = {};
    for (let i = 0; i < values.length; i++) {
      blockedIpPayload[values[i].name] = values[i].value;
    }

    // console.log({ _id: location?.state?.row[PRIMARY_KEY] });
    // INFO : call edit api
    const blockedIpResponse = await editBlockedIpApi(
      location?.state?.row[PRIMARY_KEY],
      blockedIpPayload
    );

    // INFO : check api response and show relevant alert message
    if (blockedIpResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: blockedIpResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getBlockedIpFormInputs({
      ipAddress: location?.state?.row?.ip_address || "",
    }),
  };

  const templateEvents = {
    handleBlockedIpSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <BlockedIpEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default BlockedIpEditComponent;
